export const showReminders = (invite) => {
    return !invite ||
        !invite.activated ||
        !invite.valid ||
        invite.userReminders;
}


export const loadInvite = (store, route) => {

    // Check for invite updates
    let inviteKey = localStorage ? localStorage.reminderbotInviteKey : '';
    if (route.query.inviteKey) {
        inviteKey = route.query.inviteKey;
    }

    if (inviteKey) {
        store.dispatch('registration/loadInvite', inviteKey);
    }
}
